
import React, { useEffect, useState } from "react";
import { SpecsAPI } from "../services/api";
type TreeNode = {
  text: string;
  tag: number;
};

type SpecRow = {
  specNo: number;
  componentGroup: number;
  specificationNo: number;
  detailNo: number;
  specification: string;
  detail: string;
};

type DetailOption = {
  componentNo: number;
  component: string;
};

type Props = {
  projectId: number;
  selectedNode: TreeNode | null;
};

export default function SpecificationsAccordion({
  projectId,
  selectedNode,
}: Props) {
  const [rows, setRows] = useState<SpecRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [detailOptionsByGroup, setDetailOptionsByGroup] = useState<
    Record<number, DetailOption[]>
  >({});

  useEffect(() => {
    const loadSpecs = async () => {
      if (!selectedNode) {
        setRows([]);
        return;
      }

      let scope = 0;
      let parentNo = projectId;

      if (selectedNode.tag === 0) {
        scope = 0;
        parentNo = projectId;
      } else if (selectedNode.tag > 0) {
        scope = 1;
        parentNo = selectedNode.tag;
      } else {
        scope = 5;
        parentNo = Math.abs(selectedNode.tag);
      }

      try {
        setLoading(true);
        const data: SpecRow[] = await SpecsAPI.getByNode(
          projectId,
          scope,
          parentNo
        );
        setRows(data);
      } catch (err) {
        console.error("Failed to load specifications:", err);
        setRows([]);
      } finally {
        setLoading(false);
      }
    };

    loadSpecs();
  }, [projectId, selectedNode]);

  useEffect(() => {
    const loadDetailOptions = async () => {
      if (rows.length === 0) return;

      const uniqueGroups = Array.from(
        new Set(rows.map((r) => r.componentGroup).filter(Boolean))
      );

      const missingGroups = uniqueGroups.filter(
        (group) => !detailOptionsByGroup[group]
      );

      if (missingGroups.length === 0) return;

      try {
        const results = await Promise.all(
          missingGroups.map(async (group) => ({
            group,
            options: await SpecsAPI.getDetailOptions(group),
          }))
        );

        setDetailOptionsByGroup((prev) => {
          const next = { ...prev };
          results.forEach(({ group, options }) => {
            next[group] = options;
          });
          return next;
        });
      } catch (err) {
        console.error("Failed to load detail options:", err);
      }
    };

    loadDetailOptions();
  }, [rows, detailOptionsByGroup]);

  const handleDetailChange = async (
    rowIndex: number,
    specNo: number,
    newDetailNo: number
  ) => {
    try {
      await SpecsAPI.updateDetail(specNo, newDetailNo);

      setRows((prev) =>
        prev.map((row, index) => {
          if (index !== rowIndex) return row;

          const options = detailOptionsByGroup[row.componentGroup] || [];
          const selectedOption = options.find(
            (x) => x.componentNo === newDetailNo
          );

          return {
            ...row,
            detailNo: newDetailNo,
            detail: selectedOption?.component ?? row.detail,
          };
        })
      );
    } catch (err) {
      console.error("Failed to update detail:", err);
      alert("Update failed");
    }
  };
  if (!loading && rows.length === 0) {
  return null;
}

  return (
    //  <div className="bg-white overflow-hidden">
    <div
 // className="bg-white overflow-hidden"
  style={{
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "13px",
    fontWeight: 400,
  }}
>
      {/* <div className="px-4 py-3 border-b bg-gray-50">
        <h3 className="font-semibold text-gray-700">Specifications</h3>
      </div> */}

      <div className="p-0">
        {loading ? (
          // <div className="text-sm text-gray-500">
          <div className="text-gray-500">
            Loading...</div>
        ) : rows.length === 0 ? (
          // <div className="text-sm text-gray-400">No specifications found</div>
          <div className="text-gray-400">No specifications found</div>
        ) : (
          // <table className="w-full border-collapse text-sm">
          <table className="w-full border-collapse ">
           {/* <thead>
              <tr className="bg-gray-100">
                <th className="border px-3 py-2 text-left">Specification</th>
                <th className="border px-3 py-2 text-left">Detail</th>
              </tr>
            </thead>*/}
            <tbody>
              {rows.map((row, index) => {
                const options = detailOptionsByGroup[row.componentGroup] || [];

                return (
                  // <tr key={row.specNo}>
                  <tr key={`${row.specNo}-${index}`}>
                    {/* <td className=" px-3 py-2"> */}
                    <td className="border-b border-gray-200 px-4 py-2">
                      {row.specification}</td>
                   {/*  <td className=" px-3 py-2"> */}
                   <td className="border-b border-gray-200 px-4 py-2">
                      <select
                        // className="w-full border rounded px-2 py-1 text-sm"
                          className="w-full border rounded px-2 py-1"
                        value={row.detailNo}
                        onChange={(e) =>
                          handleDetailChange(
                            index,
                            row.specNo,
                            Number(e.target.value)
                          )
                        }
                      >
                        {options.length === 0 ? (
                          <option value={row.detailNo}>{row.detail}</option>
                        ) : (
                          options.map((opt) => (
                             <option
                              key={opt.componentNo}
                              value={opt.componentNo}
                            > 
                           
                              {opt.component}
                            </option>
                          ))
                        )}
                      </select>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}